import { FormField, TextArea } from 'grommet';
import type { DetailsProps } from '@customTypes/types';

export const Details = (props: DetailsProps): JSX.Element => {
  const required: boolean = (props.required != null) ? props.required : true;
  const placeholder: string = props.placeholder || `Any additional information we can use to help you${required ? '' : ' (optional)'}`;

  return (
    <FormField
      name="details"
      htmlFor="details"
      label="Can you give us more details?"
      required={required}
    >
      <TextArea
        id="details"
        name="details"
        placeholder={placeholder}
        resize="vertical"
        style={{ minHeight:'58px' }}
      />
    </FormField>
  );
};
